
















































































































































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import ApprovalDialog from './approval-dialog.vue'
import { apiWorkOrderCompleteWorkOrder } from '@/api/work_order'

@Component({
  components: {
    ApprovalDialog
  }
})
export default class WorkOrderPane extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: any[]
    @Prop({ type: Object, required: true }) pager!: any
    @Prop({ type: Array, default: () => [] }) orderTypeList!: any[]
    @Prop({ type: Array, default: () => [] }) orderStatusList!: any[]
    @Prop({ type: Array, default: () => [] }) staffList!: any[]
    @Prop({ type: Array, default: () => [] }) selectedIds!: number[]

    // 审批对话框相关
    approvalDialogVisible = false
    currentWorkOrder: any = {}

    // 验收对话框相关
    acceptanceDialogVisible = false
    acceptanceLoading = false
    acceptanceData = {
      rating: 5,
      remark: ''
    }

    // 获取工单类型标签
    getOrderTypeLabel (type: string): string {
      const item = this.orderTypeList.find(item => item.value === type.toString())
      return item ? item.label : '-'
    }

    // 获取状态标签
    getStatusLabel (status: string): string {
      const item = this.orderStatusList.find(item => item.value === status.toString())
      return item ? item.label : '-'
    }

    // 获取状态样式类型
    getStatusType (status: string): string {
      const statusMap: any = {
        1: 'info', // 待指派 - 蓝色
        2: 'primary', // 已指派 - 深蓝色
        3: 'warning', // 进行中 - 黄色
        4: 'success', // 已完成 - 绿色
        5: 'success', // 已验收 - 绿色
        6: '', // 已取消 - 灰色（使用plain效果）
        7: 'warning', // 已转单 - 橙色
        8: 'warning', // 需补差价 - 橙色
        9: 'info' // 已报价 - 浅蓝色
      }
      return statusMap[status] || 'info'
    }

    // 获取状态标签效果
    getStatusEffect (status: string): string {
      const effectMap: any = {
        6: 'plain' // 已取消 - 灰色
      }
      return effectMap[status] || 'dark'
    }

    // 获取状态自定义类
    getStatusClass (status: string): string {
      return `status-${status}`
    }

    // 获取支付状态标签
    getPaymentStatusLabel (status: string): string {
      const statusMap: any = {
        0: '未支付',
        1: '已支付',
        2: '部分支付',
        3: '已退款'
      }
      return statusMap[status] || '-'
    }

    // 获取支付状态样式类型
    getPaymentStatusType (status: string): string {
      const statusMap: any = {
        0: 'danger',
        1: 'success',
        2: 'warning',
        3: 'info'
      }
      return statusMap[status] || 'info'
    }

    // 当前节点是否存在平台端可执行的操作（以 allow_actions 为准）
    hasNodeAllowActions (node: any): boolean {
      if (!node || node.allow_actions === undefined || node.allow_actions === null) {
        return false
      }
      try {
        let actions: any[] = []
        if (Array.isArray(node.allow_actions)) {
          actions = node.allow_actions
        } else if (typeof node.allow_actions === 'string') {
          actions = JSON.parse(node.allow_actions)
        }
        return Array.isArray(actions) && actions.length > 0
      } catch {
        return false
      }
    }

    // 表格选择事件
    @Emit('selection-change')
    handleSelectionChange (selection: any[]) {
      return selection.map(item => item.id)
    }

    // 刷新
    handleRefresh () {
      this.$emit('refresh')
    }

    // 分页大小变化
    handleSizeChange (size: number) {
      this.pager.limit = size
      this.$emit('refresh')
    }

    // 分页页码变化
    handleCurrentChange (page: number) {
      this.pager.page = page
      this.$emit('refresh')
    }

    // 查看详情
    @Emit('handle-detail')
    handleDetail (id: number) {
      return id
    }

    // 编辑
    @Emit('handle-edit')
    handleEdit (id: number) {
      return id
    }

    // 派工
    @Emit('handle-assign')
    handleAssign (id: number) {
      return id
    }

    // 取消
    @Emit('handle-cancel')
    handleCancel (id: number) {
      return id
    }

    // 报价
    @Emit('handle-quotation')
    handleQuotation (id: number) {
      return id
    }

    // 支付
    @Emit('handle-payment')
    handlePayment (id: number) {
      return id
    }

    // 审批操作
    handleApprove (row: any) {
      this.currentWorkOrder = row
      this.approvalDialogVisible = true
    }

    // 审批成功回调
    handleApprovalSuccess () {
      this.$emit('refresh')
    }

    // 执行操作
    handleExecute (row: any) {
      console.log('执行操作', row)
      // TODO: 调用执行接口
      this.$message.info('执行操作功能开发中')
    }

    // 验收操作
    handleAcceptance (row: any) {
      if (this.acceptanceLoading) return
      this.acceptanceLoading = true
      // 先跳转到详情页，然后在详情页确认验收
      this.handleDetail(row.id)
      // 重置loading状态
      setTimeout(() => {
        this.acceptanceLoading = false
      }, 500)
    }

    // 采购操作
    handlePurchase (row: any) {
      console.log('采购操作', row)
      // TODO: 调用采购接口
      this.$message.info('采购操作功能开发中')
    }

    // 入库操作
    handleWarehouse (row: any) {
      console.log('入库操作', row)
      // TODO: 调用入库接口
      this.$message.info('入库操作功能开发中')
    }

    // 完成工单操作
    handleCompleteWorkOrder (row: any) {
      this.$confirm('确认完成此工单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await apiWorkOrderCompleteWorkOrder({
            id: row.id
          })
          this.$emit('refresh')
        } catch (error) {
          console.error('完成工单失败:', error)
        }
      }).catch(() => {
        // 用户取消操作
      })
    }

    // 更多操作
    handleCommand (command: string, row: any) {
      switch (command) {
        case 'edit':
          this.handleEdit(row.id)
          break
        case 'assign':
          this.handleAssign(row.id)
          break
        case 'quotation':
          this.handleQuotation(row.id)
          break
        case 'cancel':
          this.handleCancel(row.id)
          break
        case 'payment':
          this.handlePayment(row.id)
          break
        case 'warranty':
          // 质保操作
          break
      }
    }
}
